import { view } from '@yola/ws-sdk';
import constants from '../constants/common';

const { COMPOSITE_IMAGE, INLINE_IMAGE } = constants;

function getImageTypeTrait(elementId) {
  const element = view.accessors.getLiveElement(elementId);
  return element.closest('ws-composite-item') ? COMPOSITE_IMAGE : INLINE_IMAGE;
}

export default getImageTypeTrait;
